const actions = {
    GET_PEDIDOS_ONLINE_REQUEST: 'GET_PEDIDOS_ONLINE_REQUEST',
    GET_PEDIDOS_ONLINE_SUCCESS: 'GET_PEDIDOS_ONLINE_SUCCESS',

    GET_PEDIDOS_BY_REFERENCE_CODE_REQUEST: 'GET_PEDIDOS_BY_REFERENCE_CODE_REQUEST',
    GET_PEDIDOS_BY_REFERENCE_CODE_SUCCESS: 'GET_PEDIDOS_BY_REFERENCE_CODE_SUCCESS',

    SET_PAGINATION_INFO: 'SET_PAGINATION_INFO',
    UPDATE_PEDIDOS_ONLINE: 'UPDATE_PEDIDOS_ONLINE',

    getPedidosOnline: (query) => ({ type: actions.GET_PEDIDOS_ONLINE_REQUEST, query }),
    updatePedidosOnline: (data, query) => {
        return { type: actions.UPDATE_PEDIDOS_ONLINE, payload: data, query }
    },
    getPedidosByReferenceCode: (data) => ({ type: actions.GET_PEDIDOS_BY_REFERENCE_CODE_REQUEST, payload: data }),

};
export default actions;